var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "display-product-slider layout-without-background"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10 col-md-7 mx-auto text-left text-md-center"
  }, [_c('title-section', {
    attrs: {
      "title": _vm.title,
      "text-color": _vm.titleColor
    }
  }), _vm._v(" "), _c('subtitle-section', {
    attrs: {
      "subtitle": _vm.subtitle,
      "text-color": _vm.subtitleColor
    }
  }), _vm._v(" "), _c('simple-paragraph', {
    attrs: {
      "paragraph": _vm.paragraph,
      "has-read-more": _vm.readMore
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'container-fluid': !_vm.mobile && _vm.isGridWidthLayout
    }
  }, [_c('mdm-carousel', {
    ref: "carousel",
    staticClass: "w-100 mt-2 mt-md-3",
    attrs: {
      "per-page-custom": _vm.slideCount,
      "pagination-enabled": false,
      "center-mode": true
    }
  }, _vm._l(_vm.images, function (img, index) {
    return _c('mdm-slide', {
      key: index,
      staticClass: "p-2 p-md-3 text-center"
    }, [_vm.showCarousel ? _c(_vm.componentType(img) === 'link' ? 'a' : 'div', {
      tag: "component",
      attrs: {
        "href": img.url,
        "target": img.target
      },
      on: {
        "click": function click($event) {
          return _vm.$root.$emit('generic-tracking', $event, img.tracking);
        }
      }
    }, [_c('img', {
      staticClass: "lazyload img-fluid",
      attrs: {
        "data-src": img.src,
        "data-srcset": img.srcset,
        "data-sizes": "auto",
        "alt": ""
      }
    }), _vm._v(" "), img.text ? _c('p', {
      staticClass: "pt-3 pt-md-2",
      domProps: {
        "textContent": _vm._s(img.text)
      }
    }) : _vm._e()]) : _vm._e()], 1);
  }), 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };